// ----------------------------
// Created by Bulletproof Games
//            2016
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Winline Animation Controller
//
// This class coordinates showing winlines and animating symbols

winlineAnimationController = undefined;

winlineAnimationControllerFactory = {};
winlineAnimationControllerFactory.winlineAnimationControllers = [];

winlineAnimationControllerFactory.create = function () {
  var newWinlineAnimationController = {};
  newWinlineAnimationController.skip = false;
  newWinlineAnimationController.state = "IDLE";
  newWinlineAnimationController.isAnimating = false;

  newWinlineAnimationController.initialise = function (config) {
    if (typeof resourceManager.getConfiguration().controllers === "undefined") {
      console.error("No controllers section was found in config.json");
      return;
    }

    var invalid = 0;

    // Check winline animation controller and batcher exist
    invalid += checkForUndefined(
      config,
      "config.winlineAnimationController was not found in config.json",
      true
    );
    invalid += checkForUndefined(
      config.batcher,
      "batcher not found for winlineAnimationController",
      true
    );

    // Check winline and symbol animators exist
    //        invalid += checkForUndefined(config.symbolAnimator, "symbolAnimator not found for winlineAnimationController", true);
    invalid += checkForUndefined(
      config.winlineAnimator,
      "winlineAnimator not found for winlineAnimationController",
      true
    );

    // Did we encounter an error?
    if (invalid > 0) {
      return;
    }

    // Store the plugins we need to coordinate
    newWinlineAnimationController.winlineBatcher = resourceManager.getPlugin(
      config.batcher
    );
    newWinlineAnimationController.winlineBatcher.setUseWildSymbolAnim(
      checkForUndefined(
        config.useWildSymbolAnim,
        "useWildSymbolAnim property not found for winlineAnimationController, default of FALSE will be used",
        false
      )
        ? false
        : config.useWildSymbolAnim
    );
    //newWinlineAnimationController.symbolAnimator = resourceManager.getPlugin(config.symbolAnimator);
    newWinlineAnimationController.winlineAnimator = resourceManager.getPlugin(
      config.winlineAnimator
    );

    invalid = 0;

    // Check batcher, winline and symbol animators have the correct functions defined
    invalid += checkForUndefined(
      newWinlineAnimationController.winlineBatcher.batch,
      "batch function not found for winlineBatcher " + config.winlineBatcher,
      true
    );
    invalid += checkForUndefined(
      newWinlineAnimationController.winlineAnimator.playAnimation,
      "playAnimation function not found for winlineAnimator " +
        config.winlineAnimator,
      true
    );
    invalid += checkForUndefined(
      newWinlineAnimationController.winlineAnimator.skipAnimation,
      "skipAnimation function not found for winlineAnimator " +
        config.winlineAnimator,
      true
    );

    // Did we encounter an error?
    if (invalid > 0) {
      return;
    }
  };

  newWinlineAnimationController.startWinlineAnimations = function (
    winData,
    completeCallback,
    maxWinlineAnimationTime,
    concurrently,
    preAnimsDoneCallback
  ) {
    // Check for undefined data
    if (
      checkForUndefined(
        winData,
        "winData in winlineAnimationController.startWinlineAnimations is undefined",
        true
      )
    )
      return;
    if (
      checkForUndefined(
        completeCallback,
        "completeCallback in winlineAnimationController.startWinlineAnimations is undefined",
        true
      )
    )
      return;

    newWinlineAnimationController.concurrently = concurrently;

    // First get the batcher to change winline data into winline animation sequence
    newWinlineAnimationController.sequenceData =
      newWinlineAnimationController.winlineBatcher.batch(
        winData,
        newWinlineAnimationController.name,
        newWinlineAnimationController.slotMachine
      );
    newWinlineAnimationController.completeCallback = completeCallback;
    newWinlineAnimationController.skip = false;
    newWinlineAnimationController.maxWinlineAnimationTime =
      maxWinlineAnimationTime;
    if (preAnimsDoneCallback !== undefined) {
      newWinlineAnimationController.preAnimsDoneCallback = preAnimsDoneCallback;
    } else {
      newWinlineAnimationController.preAnimsDoneCallback = function () {};
    }

    newWinlineAnimationController.sequenceData =
      newWinlineAnimationController.sequenceData.filter(function (data) {
        if (data.type === "Winline") {
          return true;
        }
      });
    newWinlineAnimationController.sequenceData =
      newWinlineAnimationController.sequenceData.sort(function (data1, data2) {
        if (data1.data.winningLine > data2.data.winningLine) {
          return 1;
        } else if (data1.data.winningLine < data2.data.winningLine) {
          return -1;
        } else {
          return 0;
        }
      });

    // Kick off animation process
    newWinlineAnimationController.currentAnimationIndex = 0;
    newWinlineAnimationController.winlineAnimator.begin();
    if (concurrently) {
      newWinlineAnimationController.playAllAnimations(
        winData.totalLineWinnings
      );
    } else {
      newWinlineAnimationController.playNextAnimation();
    }
  };

  newWinlineAnimationController.skipAnimations = function () {
    newWinlineAnimationController.skip = true;

    newWinlineAnimationController.winlineAnimator.skipAnimation();

    newWinlineAnimationController.winlineAnimator.end();
  };

  newWinlineAnimationController.playNextAnimation = function () {
    // Returns true is there is another animation to play, and we are not skipping
    if (
      newWinlineAnimationController.skip ||
      newWinlineAnimationController.sequenceData.length ===
        newWinlineAnimationController.currentAnimationIndex
    ) {
      return false;
    }

    newWinlineAnimationController.animationComplete = false;
    newWinlineAnimationController.state = "PLAYING_ANIMATION";

    var seq =
      newWinlineAnimationController.sequenceData[
        newWinlineAnimationController.currentAnimationIndex
      ];

    //soundManager.play("winline");
    newWinlineAnimationController.animationsPlaying = 1;
    newWinlineAnimationController.winlineAnimator.playAnimation(
      seq,
      newWinlineAnimationController.animationCompleteCallback,
      newWinlineAnimationController.preAnimsDoneCallback,
      !newWinlineAnimationController.concurrently
    );

    return true;
  };

  newWinlineAnimationController.playAllAnimations = function (winnings) {
    newWinlineAnimationController.animationComplete = false;
    newWinlineAnimationController.state = "PLAYING_ANIMATION";

    var remainingWinlineAnimations = 0;
    var remainingSymbolAnimations = 0;
    for (
      var i = newWinlineAnimationController.currentAnimationIndex;
      i < newWinlineAnimationController.sequenceData.length;
      i++
    ) {
      if (
        remainingSymbolAnimations === 0 &&
        newWinlineAnimationController.sequenceData[i].type !== "Symbol"
      )
        remainingWinlineAnimations++;
      if (newWinlineAnimationController.sequenceData[i].type !== "Winline")
        remainingSymbolAnimations++;
    }

    const stake = resourceManager.getController("stakeController").BaseStake;
    if (winnings <= stake) {
    } else if (winnings < stake * 5) {
      soundManager.play("win_lvl1_v1");
    } else if (winnings < stake * 10) {
      soundManager.play("win_lvl2_v1");
    } else if (winnings < stake * 20) {
      soundManager.play("win_lvl3_v1");
    } else {
      soundManager.play("win_lvl4_v1");
    }

    newWinlineAnimationController.animationsPlaying = 1;
    newWinlineAnimationController.winlineAnimator.playAnimations(
      newWinlineAnimationController.sequenceData,
      newWinlineAnimationController.animationCompleteCallbackAll,
      newWinlineAnimationController.preAnimsDoneCallback,
      !newWinlineAnimationController.concurrently
    );
  };

  newWinlineAnimationController.animationCompleteCallback = function () {
    if (--newWinlineAnimationController.animationsPlaying === 0) {
      var seq =
        newWinlineAnimationController.sequenceData[
          newWinlineAnimationController.currentAnimationIndex
        ];
      newWinlineAnimationController.currentAnimationIndex++;

      var remainingWinlineAnimations = 0;
      var remainingSymbolAnimations = 0;
      for (
        var i = newWinlineAnimationController.currentAnimationIndex;
        i < newWinlineAnimationController.sequenceData.length;
        i++
      ) {
        if (
          remainingSymbolAnimations === 0 &&
          newWinlineAnimationController.sequenceData[i].type !== "Symbol"
        )
          remainingWinlineAnimations++;
        if (newWinlineAnimationController.sequenceData[i].type !== "Winline")
          remainingSymbolAnimations++;
      }

      if (newWinlineAnimationController.playNextAnimation() === false) {
        // All animations complete
        newWinlineAnimationController.isAnimating = false;
        newWinlineAnimationController.completeCallback();
      }
    }
  };

  newWinlineAnimationController.animationCompleteCallbackAll = function () {
    //newWinlineAnimationController.isAnimating = false;
    newWinlineAnimationController.completeCallback();
  };

  winlineAnimationControllerFactory.winlineAnimationControllers.push(
    newWinlineAnimationController
  );

  // For backwards compatibility
  if (
    winlineAnimationControllerFactory.winlineAnimationControllers.length === 1
  ) {
    winlineAnimationController = newWinlineAnimationController;
  }

  return newWinlineAnimationController;
};

resourceManager.registerController(
  "gameWinlineAnimationController",
  winlineAnimationControllerFactory.create
);
